module.exports = __webpack_public_path__ + "img/login-logo.03d61bc7.png";